// @flow
import * as React from 'react';
import { CallHistoryItemsQuery, NoData, Portal } from '../../../../../shared';
import { Stack, Typography } from '@mui/material';
import _ from 'lodash';
import { getUserName } from '@coverright/utils';
import { CallSentiment } from '../../call-sentiment';
import { useClient } from '../../../hooks/client-context';

type Props = {
  call?: CallHistoryItemsQuery['callHistoryItems']['data'][0],
  loading: boolean
};
export const CallAiAnalysis = ({call, loading}: Props) => {
  const client = useClient();

  return (
    <Portal gap={3} p={2}>
      {loading && !call?.callHistoryAnalysis &&  <NoData>Loading...</NoData>}
      {!loading && !call?.callHistoryAnalysis && <NoData />}

      {call?.callHistoryAnalysis && <>
        <Stack gap={.5}>
          <Typography>Key Topics</Typography>
          {call && !call.callHistoryAnalysis?.topics ? <NoData/> : <Typography color={'text.secondary'} variant={'body2'}>
            {call?.callHistoryAnalysis?.topics?.map(_.upperFirst).join(', ')}
          </Typography>}
        </Stack>

        <Stack gap={.5}>
          <Typography>
            AI Call Summary  {call?.agent ? `(${getUserName(call.agent)} and ${client ? getUserName(client) : ''})` : ''}
          </Typography>
          {call && !call.callHistoryAnalysis?.summary ? <NoData/> : <Typography color={'text.secondary'} variant={'body2'} sx={{whiteSpace: 'pre-line'}}>
            {call?.callHistoryAnalysis?.summary}
          </Typography>}
        </Stack>

        <Stack gap={1.5}>
          <Typography>
            On-Call Sentiment Analysis
          </Typography>
          {call?.callHistoryAnalysis?.sentiment ? <div>
            <CallSentiment sentiment={call?.callHistoryAnalysis?.sentiment}/>
          </div> : <NoData/>}

        </Stack>
      </>}

    </Portal>
  );
};
